/**
 * @fileoverview Primary contact title and name fields for ContactsData.
 */

import React from "react";
import Select from "react-select";
import { getSelectedOption, selectStyles } from "../../../utils/common";
import styles from "./ContactsData.module.css";

export const PrimaryContactIdentityFields = ({ form, onFieldChange }) => {
  const {
    t,
    titleOptions,
    selectedTitle,
    setSelectedTitle,
    nombre,
    setNombre,
    segundoNombre,
    setSegundoNombre,
    apellidoPaterno,
    setApellidoPaterno,
    getFieldValidationState,
    getErrorMessage,
    handleValidatedFieldChange,
  } = form;

  return (
    <div className={styles.inputRow}>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.contactsData.titleLabel")}
        </label>
        <Select
          value={getSelectedOption(titleOptions, selectedTitle)}
          onChange={(selectedOption) => {
            setSelectedTitle(selectedOption.value);
            onFieldChange("contacto1Titulo", selectedOption.value);
          }}
          options={titleOptions}
          placeholder={t("components.contactsData.titlePlaceholder")}
          styles={selectStyles}
          className="select__control"
        />
        <p className={styles.notVisibleFieldMessage}>
          *{t("components.corporateIdentity.notVisibleFieldMessage")}
        </p>
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.contactsData.nameLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState("contacto1Nombre", nombre) === "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.contactsData.namePlaceholder")}
          onChange={(e) => {
            const value = e.target.value;
            setNombre(value);
            handleValidatedFieldChange("contacto1Nombre", value);
          }}
          value={nombre}
          maxLength={100}
        />
        {getErrorMessage("contacto1Nombre") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("contacto1Nombre")}
          </p>
        )}
      </div>
      <div className={`${styles.inputGroup} ${styles.tabletBottomSpacing}`}>
        <label className={styles.inputLabel}>
          {t("components.contactsData.middleNameLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState("contacto1SegundoNombre", segundoNombre) ===
            "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.contactsData.middleNamePlaceholder")}
          onChange={(e) => {
            const value = e.target.value;
            setSegundoNombre(value);
            handleValidatedFieldChange("contacto1SegundoNombre", value);
          }}
          value={segundoNombre}
          maxLength={100}
        />
        {getErrorMessage("contacto1SegundoNombre") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("contacto1SegundoNombre")}
          </p>
        )}
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.contactsData.fatherLastNameLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState(
              "contacto1ApellidoPaterno",
              apellidoPaterno,
            ) === "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.contactsData.fatherLastNamePlaceholder")}
          onChange={(e) => {
            const value = e.target.value;
            setApellidoPaterno(value);
            handleValidatedFieldChange("contacto1ApellidoPaterno", value);
          }}
          value={apellidoPaterno}
          maxLength={100}
        />
        {getErrorMessage("contacto1ApellidoPaterno") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("contacto1ApellidoPaterno")}
          </p>
        )}
      </div>
    </div>
  );
};

export const PrimaryMotherLastNameField = ({ form }) => {
  const {
    t,
    apellidoMaterno,
    setApellidoMaterno,
    getFieldValidationState,
    getErrorMessage,
    handleValidatedFieldChange,
  } = form;

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {t("components.contactsData.motherLastNameLabel")}
      </label>
      <input
        type="text"
        className={`${styles.input} ${
          getFieldValidationState("contacto1ApellidoMaterno", apellidoMaterno) ===
          "error"
            ? styles.inputError
            : ""
        }`}
        placeholder={t("components.contactsData.motherLastNamePlaceholder")}
        onChange={(e) => {
          const value = e.target.value;
          setApellidoMaterno(value);
          handleValidatedFieldChange("contacto1ApellidoMaterno", value);
        }}
        value={apellidoMaterno}
        maxLength={100}
      />
      {getErrorMessage("contacto1ApellidoMaterno") && (
        <p className={styles.errorMessage}>
          {getErrorMessage("contacto1ApellidoMaterno")}
        </p>
      )}
    </div>
  );
};
